import styled from "styled-components";
import { theme } from "styled-tools";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";
import vectorMobile from "../../Assets/Img/VectorMobile.png";
import bgHomeMobile from "../../Assets/Img/bgHomeMobile.png";

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 680px;
  width: 100%;
  margin-left: 96px;
`;

export const IconSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;

  p {
    margin: 23px 0 0 0;
  }

  img:nth-of-type(1) {
    margin: 23px 0 0 0;
    width: 206px;
    height: 138px;
  }

  img:nth-of-type(2) {
    width: 300px;
    height: 99px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 99px 0;
  align-items: center;

  p {
    font-family: Poppins;
    width: 802px;
  }

  ${mediaQuery[Screen.mobile]} {
    p {
      max-width: 323px;
      font-family: Montserrat;
      font-size: 20px;
    }
  }
`;

export const SectionAccount = styled.div`
  ${mediaQuery[Screen.mobile]} {
    max-width: 377px;
    margin-inline: auto;

    h1 {
      font-size: 24px;
      margin-bottom: 20px;
    }

    p {
      font-size: 20px;
    }
  }
`;

export const SectionInicia = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 63px 0;
  align-items: center;

  ${mediaQuery[Screen.mobile]} {
    margin: 0;

    h1 {
      margin-block: 40px;
      font-size: 24px;
      color: ${theme("Primary_600")};
    }
  }
`;

export const IconsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 300px;

  ${mediaQuery[Screen.xs]} {
    height: 230px;
  }

  ${mediaQuery[Screen.sm]} {
    height: 230px;
  }

  ${mediaQuery[Screen.md]} {
    height: 230px;
  }
`;

export const IconsSectionAccount = styled(IconsSection)`
  ${mediaQuery[Screen.xs]} {
    flex-direction: column;
    height: auto;
    align-items: center;
  }

  ${mediaQuery[Screen.sm]} {
    flex-direction: column;
    height: auto;
    align-items: center;
  }

  ${mediaQuery[Screen.md]} {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
`;

export const CardSection = styled.div`
  width: 200px;
  margin: 0 70px;
  text-align: -webkit-center;

  ${mediaQuery[Screen.mobile]} {
    width: 244px;
    margin: 0 15px;

    p {
      font-size: 20px;
    }
  }
`;

export const CardSectionAccount = styled(CardSection)`
  justify-content: center;
  svg {
    height: 78px;
    width: auto;
  }

  ${mediaQuery[Screen.mobile]} {
    margin: 64px 15px;

    svg {
      height: 78px;
      width: 120px;
    }
  }
`;

export const IconCard = styled.div`
  display: flex;
  flex-direction: column;
  text-align: -webkit-center;
  border: 2px ${theme("Bright_Gray")} solid;
  border-radius: 90px;
  width: 157px;
  height: 157px;
  align-self: center;
  justify-content: center;
  align-items: center;

  ${mediaQuery[Screen.mobile]} {
    width: 100px;
    height: 100px;
  }

  img {
    align-self: center;
    margin: 41px 0;

    ${mediaQuery[Screen.mobile]} {
      margin: 20px 0;
      width: 50px;
      height: 50px;
    }
  }
`;

export const StepSection = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  width: 38px;
  height: 38px;
  border-radius: 60px;
  background: ${theme("Gradients_01")};
  color: ${theme("White")};
  align-self: center;
  justify-content: center;
`;

export const SectionMobile = styled.div`
  margin-top: 40px;
  display: none;
  ${mediaQuery[Screen.xs]} {
    display: flex;
    flex-direction: column;
  }

  ${mediaQuery[Screen.sm]} {
    display: flex;
    flex-direction: column;
  }

  ${mediaQuery[Screen.md]} {
    display: flex;
    flex-direction: column;
  }
`;

export const ImgMobile = styled.div`
  display: flex;
  margin: 48px 0 0 0;
  height: 369px;
  width: 100%;
  background: url(${vectorMobile}), url(${bgHomeMobile});
  background-size: 216px 271px, cover;
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: bottom;
  justify-content: right;
`;

export const CardStep = styled.div`
  width: 100%;
  height: auto;
  max-height: 450px;
  background-color: ${theme("Bright_Gray")};
  display: flex;
  flex-direction: row;
  margin: 63px 0;

  div {
    align-items: center;
  }

  ${mediaQuery[Screen.xs]} {
    display: none;
    margin: 24px 0;
  }

  ${mediaQuery[Screen.sm]} {
    display: none;
    margin: 24px 0;
  }

  ${mediaQuery[Screen.md]} {
    display: none;
    margin: 24px 0;
  }
`;

export const CardStepMovile = styled.div`
  width: 100%;
  height: auto;
  background-color: ${theme("White")};
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  justify-content: center;
  border-bottom: 2px ${theme("Amaranth_Red")} solid;

  ${mediaQuery[Screen.lg]} {
    display: none;
  }
  ${mediaQuery[Screen.xl]} {
    display: none;
  }

  ${mediaQuery[Screen.xxl]} {
    display: none;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0 0 120px;

  ${mediaQuery[Screen.mobile]} {
    padding: 0;
    margin-inline: 24px;
    width: auto;

    p {
      font-size: 16px;
      margin-block: 20px;
    }

    &.subtitle {
      p:first-child {
        font-size: 18px;
      }
    }
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 370px;
  justify-content: center;
  align-items: center;
  margin-top: 63px;
  margin-bottom: 90px;

  ${mediaQuery[Screen.mobile]} {
    background: ${theme("White")};
    margin-top: 24px;
    height: 160px;
    margin-bottom: 0px;
  }
`;

export const DescriptionStep = styled(Description)`
  background: ${theme("White")};

  ${mediaQuery[Screen.xs]} {
    height: 161px;
    margin: 24px 0;
  }

  ${mediaQuery[Screen.sm]} {
    height: 161px;
    margin: 24px 0;
  }

  ${mediaQuery[Screen.md]} {
    height: 161px;
    margin: 24px 0;
  }
`;

export const TitleSectionStep = styled.div`
  display: flex;
  flex-direction: column;
  width: 623px;
  max-width: 623px;

  ${mediaQuery[Screen.mobile]} {
    width: 100%;

    p {
      font-size: 18px;
      font-weight: 400;
      margin-inline: 24px;
    }

    span {
      font-weight: 600;
    }
  }
`;

export const Span = styled.span`
  color: ${theme("Primary_600")};

  ${mediaQuery[Screen.mobile]} {
    color: ${theme("Eerie_Black")};
  }
`;

export const IconSectionStep = styled.div`
  display: flex;
  flex-direction: row;

  ${mediaQuery[Screen.xs]} {
    div {
      width: 40px;
      height: 40px;
    }

    svg {
      height: 40px;
      width: 40px;
    }
  }

  ${mediaQuery[Screen.sm]} {
    div {
      width: 40px;
      height: 40px;
    }

    svg {
      height: 40px;
      width: 40px;
    }
  }

  ${mediaQuery[Screen.md]} {
    div {
      width: 40px;
      height: 40px;
    }

    svg {
      height: 40px;
      width: 40px;
    }
  }
`;

export const SectionButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Line = styled.hr`
  width: 100%;
  border: 2px ${theme("Dark_Silver")} solid;

  ${mediaQuery[Screen.lg]} {
    display: none;
  }
  ${mediaQuery[Screen.xl]} {
    display: none;
  }

  ${mediaQuery[Screen.xxl]} {
    display: none;
  }
`;

export const AddSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 650px;
  align-items: center;
  text-decoration-line: underline;
  margin-bottom: 60px;

  ${mediaQuery[Screen.mobile]} {
    margin-bottom: 0;
    p {
      font-size: 16px;
    }
  }
`;

export const ContainerSection = styled.div`
  padding-inline: 24px;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;

  ${mediaQuery[Screen.mobile]} {
    img: first-child {
      height: 33px;
      margin-right: 15px;
    }

    img:nth-child(2) {
      height: 60px;
      margin-left: 15px;
    }
  }
`;

export const FormBeneficiary = styled.form`
  display: contents;
`;

export const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border: none;
  background: none;
`;

export const Asterisk = styled.span`
  color: ${theme("Amaranth_Red")};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  font-family: "Montserrat";
  margin: 0 5px 0 -7px;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;

  p {
    font-size: 10px;
  }
`;
